import { PersonPortalState } from '@app/models/person-portal-state'

export class LocalStorageUtilities {

   public static getPersonPortalState(): PersonPortalState {
      let personJSON: string = JSON.parse(sessionStorage.getItem('person-portal-state'));
      return new PersonPortalState().deserialize(personJSON);
   }

   public static setPersonPortalState(personPortalState: PersonPortalState): void {    
      sessionStorage.setItem('person-portal-state', JSON.stringify(personPortalState));
   }

   public static clearPersonPortalState(): void {
      sessionStorage.removeItem('person-portal-state');
   }
}
